"use client";

import React, { useState, useRef } from "react";
import { ChevronRight, Info, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function HeroContent() {
  const {
    products,
    loading
  } = useEcommerceProducts();
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const containerRef = useRef<HTMLDivElement>(null);
  const product = products[0];
  const productId = product?.id;
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) return;
    const {
      left,
      top,
      width,
      height
    } = containerRef.current.getBoundingClientRect();
    const x = (e.clientX - left) / width - 0.5;
    const y = (e.clientY - top) / height - 0.5;
    setMousePosition({
      x,
      y
    });
  };
  const handleMouseLeave = () => {
    setMousePosition({
      x: 0,
      y: 0
    });
  };
  return <div data-section-id="5548" ref={containerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} className="relative z-10 mx-auto grid min-h-[80vh] max-w-7xl grid-cols-1 items-center gap-12 px-6 py-20 lg:grid-cols-2 lg:gap-0">
      {}
      <div className="flex flex-col items-start space-y-8 text-left">
        <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/5 px-3 py-1 text-sm font-medium text-primary backdrop-blur-md">
          <span className="mr-2 flex h-2 w-2">
            <span className="absolute inline-flex h-2 w-2 animate-ping rounded-full bg-primary opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary"></span>
          </span>
          Tecnologia de Ponta
        </div>

        <h1 className="text-5xl font-bold tracking-tighter text-transparent sm:text-7xl lg:text-8xl bg-gradient-to-br from-white via-primary to-primary/40 bg-clip-text">
          INSPEÇÃO REIMAGINADA.
          <br />
          <span className="text-white">SEM LIMITES.</span>
        </h1>

        <p className="max-w-xl text-lg text-muted-foreground sm:text-xl">
          Fabricação própria de drones e softwares de elite projetados para os ambientes industriais mais desafiadores e confinados do mundo.
        </p>

        <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-center">
          {}
          <div className="w-full sm:w-auto">
            {loading ? <Button disabled className="h-12 w-full rounded-full px-8 sm:w-auto">
                Carregando...
              </Button> : <Link to="/#contato" className="w-full sm:w-auto">
              <Button className="h-12 w-full rounded-full bg-primary px-8 text-primary-foreground shadow-[0_0_20px_rgba(88,179,59,0.3)] transition-all hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(88,179,59,0.5)] sm:w-auto">
                Agende uma demonstração
                <ChevronRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
              </Link>}
          </div>

          {}
          <Link to="/#sobre" className="w-full sm:w-auto">
            <Button variant="ghost" size="lg" className="group h-12 w-full rounded-full border border-white/20 text-white hover:bg-white/10 sm:w-auto">
              Saiba mais
              <ChevronRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>

        {}
        <div className="flex items-center gap-6 pt-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Smartphone className="h-4 w-4 text-primary" />
            <span>Software Proprietário</span>
          </div>
          <div className="flex items-center gap-2">
            <Info className="h-4 w-4 text-primary" />
            <span>Treinamento Incluso</span>
          </div>
        </div>
      </div>

      {}
      <div className="relative flex items-center justify-center perspective-1000">
        {}
        <div className="absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/20 blur-[100px] filter" />
        
        <div className="relative transition-transform duration-100 ease-out will-change-transform" style={{
        transform: `translate(${mousePosition.x * -30}px, ${mousePosition.y * -30}px) rotateY(${mousePosition.x * 10}deg) rotateX(${mousePosition.y * -10}deg)`
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/drone.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/drone.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608045/img/drone.png-wvc-sizes" alt="Drone Volither V1 Industrial" className="relative z-10 h-auto w-full max-w-[400px] object-contain drop-shadow-2xl lg:max-w-[500px]" loading="lazy" />
          
          {}
          <div className="absolute -bottom-12 left-1/2 h-8 w-3/4 -translate-x-1/2 rounded-[100%] bg-black/40 blur-xl" />
        </div>
      </div>
    </div>;
}
export default function InovacaoEmDestaque() {
  const wp_query_params = {
    search: "Volither V1",
    per_page: 1,
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="inspeção-sem-limites" className="dark bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0 z-0">
        <div className="absolute -left-[10%] -top-[10%] h-[50vh] w-[50vw] rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute -right-[10%] bottom-[10%] h-[50vh] w-[50vw] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)]" />
      </div>

      <EcommerceProductsProvider wp_query={{
      search: "Volither V1",
      per_page: 1,
      status: ["publish"]
    }} postType="product">
        <HeroContent />
      </EcommerceProductsProvider>
    </section>;
}